let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("gcDrK")).then(() => parcelRequire('lbWy3'));